
const emptyBeeTemplate: any = {
    page: {
        body: {
            container: { style: { "background-color": "#FFFFFF" } },
            content: {
                computedStyle: {
                    linkColor: "#0000FF",
                    messageBackgroundColor: "transparent",
                    messageWidth: "600px",
                },
                style: {
                    color: "#000000",
                    "font-family": "Arial, 'Helvetica Neue', Helvetica, sans-serif",
                },
            },
            type: "mailup-bee-page-properties",
            webFonts: [],
        },
        description: "",
        rows: [
            {
                type: "one-column-empty",
                container: {
                    style: {
                        "background-color": "transparent",
                        "background-image": "none",
                        "background-repeat": "no-repeat",
                        "background-position": "top left",
                    },
                },
                content: {
                    style: {
                        "background-color": "transparent",
                        color: "#000000",
                        width: "500px",
                        "background-image": "none",
                        "background-repeat": "no-repeat",
                        "background-position": "top left",
                    },
                },
                columns: [
                    {
                        "grid-columns": 12,
                        modules: [],
                        style: {
                            "background-color": "transparent",
                            "padding-top": "5px",
                            "padding-right": "0px",
                            "padding-bottom": "5px",
                            "padding-left": "0px",
                            "border-top": "0px solid transparent",
                            "border-right": "0px solid transparent",
                            "border-bottom": "0px solid transparent",
                            "border-left": "0px solid transparent",
                        },
                    },
                ],
            },
        ],
        template: { name: "template-base", type: "basic", version: "2.0.0" },
        title: "",
    },
}

export default emptyBeeTemplate